const INTERVAL_WAIT_TIME = 200;
const INTERVAL_10_SEC_MAX = 50; // 50 intervals of 200ms is 10 seconds 
/**
 * Waits for element to be added to the DOM within 1 minute, if the element
 * is found within that time, invoke supplied callback function
 * @param {string} selector 
 * @param {function} cb 
 */
const waitForElement = (selector, cb) => {
  let timer = null;
  let intervalCounter = 1;
  // ever 200 ms try to find the selector and invoke callback
  timer = setInterval(() => {
    const element = document.querySelector(selector);
    // self destruct if element is not found after 10 seconds
    if(intervalCounter > INTERVAL_10_SEC_MAX) {
      clearInterval(timer);
    }
    // element has been found 
    if(element) {
      clearInterval(timer);
      cb(element);
    }
    // count interval execution
    intervalCounter++;
  }, INTERVAL_WAIT_TIME);
}

/**
 * Finds the azure b2c login paceholder div, then handles some logic once its 
 * present FYI: this placeholder div is targeted by a vendor external script
 * See comment on ~/CMS/PatternLibrary/src/partials/msh-azure/form-MFA.html:12
 * for more details.
 */
const findAzureAuthAndProcess = () => {
  // this is the div id of the azure auth component, child nodes are rendered 
  // at an unknown time in the future.
  const apiElement = document.querySelector('#api');
  if(apiElement) {
    waitForElement('#retryCode', (element) => {
      element.setAttribute("tabindex", 0);
    });
  }
}

export default findAzureAuthAndProcess;